<div>
    <div class="dialog-headline" fxLayout="row wrap" fxLayoutAlign="space-between start">
        <h2 class="dialog-title" mat-dialog-title>{{'Plus détails' | translate}}</h2>
        <button class="dialog-close-btn" mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <app-fiche-consultation [dataColumnsAr]="dataColumns"
                                [dataColumnsEn]="dataColumns"
                                [dataColumns]="dataColumns"
                                [data]="certeficatesDetails"
                                [label]="'Informations certificat'"
                                [labels]="labels"
                                [langue]="appTranslateService.getDefaultLang()"
        ></app-fiche-consultation>
    </div>
</div>
